import * as React from 'react';
import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm',
          'placeholder:text-slate-400',
          'focus:outline-none focus:border-brand-rose/40 focus:ring-2 focus:ring-brand-rose/10',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'transition-colors duration-200 resize-y',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
